import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { CardStateService } from '../services/card-state.service';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<unknown> {
  constructor(private cardState: CardStateService) {}

  canDeactivate(): boolean {
    if (this.cardState.isAnyDirty()) {
      return confirm('You have unsaved changes. Are you sure you want to leave this page?');
    }
    return true;
  }
}


